import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('pqyCpnyPopupStore', Object.keys(getters)),
	...mapState('pqyCpnyPopupStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('pqyCpnyPopupStore', Object.keys(actions)),
	...mapMutations('pqyCpnyPopupStore', Object.keys(mutations))
};
